import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Public activation page — doctor lands here from the email link. */
export default function Activate() {
  const { token } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState({ phase: "loading" });

  useEffect(() => {
    let m = true;
    axios.get(`${API}/auth/activate/${token}`)
      .then((r) => { if (m) setState({ phase: "ok", data: r.data }); })
      .catch((e) => { if (m) setState({ phase: "err", err: e?.response?.data?.detail || "Activation failed" }); });
    return () => { m = false; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-4">
      <div className="card-soft p-10 max-w-md w-full text-center">
        <div className="text-[11px] uppercase tracking-widest text-[#8A9992]">HealthCircles · Modern EMR</div>
        {state.phase === "loading" && (
          <>
            <div className="mt-8 flex justify-center"><Loader2 size={40} className="animate-spin text-[#0A4C36]" /></div>
            <div className="mt-4 text-sm text-[#47554D]">Activating your account…</div>
          </>
        )}
        {state.phase === "ok" && (
          <>
            <div className="mt-8 flex justify-center">
              <div className="w-16 h-16 rounded-full bg-[#E6F0EC] flex items-center justify-center">
                <CheckCircle2 size={28} className="text-[#0A4C36]" />
              </div>
            </div>
            <h1 className="mt-5 text-2xl font-semibold text-[#0A4C36]" style={{ fontFamily: "Instrument Sans" }}>
              {state.data?.status === "already_active" ? "Already active" : "You're all set"}
            </h1>
            <p className="mt-3 text-sm text-[#47554D]">
              Welcome{state.data?.name ? `, Dr. ${state.data.name.replace(/^Dr\.?\s*/i, "")}` : ""}. Your Health Circles
              account for <b>{state.data?.email}</b> is now active.
            </p>
            <button
              onClick={() => nav("/login")}
              data-testid="activate-signin"
              className="btn-emerald mt-8 mx-auto"
            >
              Sign in <ArrowRight size={14} />
            </button>
          </>
        )}
        {state.phase === "err" && (
          <>
            <div className="mt-8 flex justify-center">
              <div className="w-16 h-16 rounded-full bg-[#F8E7DF] flex items-center justify-center">
                <XCircle size={28} className="text-[#B14A2A]" />
              </div>
            </div>
            <h1 className="mt-5 text-2xl font-semibold text-[#B14A2A]" style={{ fontFamily: "Instrument Sans" }}>Activation failed</h1>
            <p className="mt-3 text-sm text-[#47554D]">{state.err}</p>
            <p className="mt-2 text-xs text-[#8A9992]">Please ask the admin to resend the activation link.</p>
          </>
        )}
      </div>
    </div>
  );
}
